import { Box } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { CustomMenuMobile } from '@/components/shared/components/CustomMenuMobile';
import { Logo } from '@/components/shared/components/Logo/Logo';
import { MainMenu } from '@/components/shared/components/MainMenu';
import { MenuBottom } from '@/components/shared/components/MenuBottom';
import { usePageContext } from '@/contexts/PageContext/PageContext';

export const MobileMenu = () => {
  const {
    state: { showMobileLeftMenu },
    actions: { setShowMobileLeftMenu },
  } = usePageContext();

  return (
    <CustomMenuMobile
      isOpen={showMobileLeftMenu}
      setIsOpen={setShowMobileLeftMenu}
      render={
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
            boxSizing: 'border-box',
            padding: '20px 20px 5px',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          <Box style={{ maxWidth: '100%' }}>
            <Box
              style={{
                width: '100%',
              }}
            >
              <Link to={'/'}>
                <Logo />
              </Link>
            </Box>
            <MainMenu />
          </Box>
          <Box>
            <MenuBottom />
          </Box>
        </Box>
      }
    />
  );
};
